import { CompetitorsByVisibility } from '../competitors-by-visibility/CompetitorsByVisibility'
import { CompetitorsTable } from '../competitors-table/CompetitorsTable'
import clsx from 'clsx'

import styles from './Competitors.module.scss'

export const Competitors = () => {
  return (
    <section className={clsx(styles.wrapper)}>
      <CompetitorsByVisibility />
      <CompetitorsTable />
    </section>
  )
}
